/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { DateRangePickerComponent,PresetsDirective, PresetDirective  } from '@syncfusion/ej2-react-calendars';
import PropTypes from "prop-types"
import moment from 'moment';
import '../wa_template.scss';

import searchIcon from '../../../_assets/images/search-icon.png';
import DateDropdown from "./date-dropdown/index";
import FilterDropdown from "./filter-dropdown/index";
import {monthStart, today , yesterday, weekEnd } from 'utils/dateFormat'

import Close from "_assets/images/close.png";

function FilterTable({searchKey, ListAgent, isListStatus, setUpdatedChange, isUpdatedChange, setFilter, isFilter,changeCriteria}) {
    const [isShowFilter, setShowFilter] = useState(false)
    const [isShowDate, setShowDate] = useState(false)
    const [isSavedFilter, setSavedFilter] = useState([])
    const [isSearch, setSearch] = useState('');
    const [isDateValue, setDateValue] = useState('All Time');
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [isTextDate, setTextDate] = useState("All Time")
    const [rangeDate, setRangeDate] = useState([new Date(), new Date()]);
    const [timer, setTimer] = useState(null)
    // const {combine, afterToday, allowedMaxDays} = DateRangePicker;
    const listenerRef = useRef();

    useEffect( () => {
        handleUpdatedFilter();
      }, [isSavedFilter]);

    function handleOnDaterange() {
        if (listenerRef.current.state.active) {
            listenerRef.current.close();
        }
        else {
            listenerRef.current.open();
            setShowDate(false);
        }
    }
    function onDateChange(value) {
        let updatedList = isFilter
        updatedList.start_date = moment(value[0]).format('YYYY-MM-DD');
        updatedList.end_date = moment(value[1]).format('YYYY-MM-DD');
        
        var defaultDate= [...isSavedFilter.filter(d => d.type !== 'date'), {type: 'date', value: 'Custom Date'}]
        setSavedFilter(defaultDate);
        
        setFilter(updatedList);
    }

    function handleUpdatedFilter() {
        console.log('isSavedFilter',isSavedFilter);
        setShowFilter(false);
        setShowDate(false);
        // isPagination({ page: 1, limit: 10})
        changeCriteria({ page: 1, limit: 10});
        setUpdatedChange(!isUpdatedChange)
        let updatedList = isFilter

        // looking for channel data
        let filteredApplication = []
        if (isSavedFilter.filter(d => d.type === 'application').length > 0) {
            for (let index = 0; index < isSavedFilter.filter(d => d.type === 'application').length; index++) {
                filteredApplication.push(isSavedFilter.filter(d => d.type === 'application')[index]?.value.toLowerCase())
            }
        }

        // looking for label data
        let filteredStatus = []
        if (isSavedFilter.filter(d => d.type === 'status').length > 0) {
            for (let index = 0; index < isSavedFilter.filter(d => d.type === 'status').length; index++) {
                let arr = isListStatus.filter(d => d.value === isSavedFilter.filter(d => d.type === 'status')[index].value)
                filteredStatus.push(arr[0]?.value)
            }  
        }


        // looking for date data
        let dateD = isSavedFilter.filter(d => d.type === 'date')
        switch (dateD[0]?.value) {
            case "All Time":
                setDateValue('All Time');
                updatedList.start_date = '';
                updatedList.end_date = '';
                break;

            case "Today":
                setDateValue('Today');
                updatedList.start_date = moment().format('YYYY-MM-DD');
                updatedList.end_date = moment().format('YYYY-MM-DD');
                break;


            case "Yesterday":
                setDateValue('Yesterday');
                updatedList.start_date = moment().subtract(1,'d').format('YYYY-MM-DD');
                updatedList.end_date = moment().format('YYYY-MM-DD');
                break;
        
            case "Last 7 Days":
                setDateValue('Last 7 Days');
                updatedList.start_date = moment(value.value[0]).format('YYYY-MM-DD');
                updatedList.end_date = moment(value.value[1]).format('YYYY-MM-DD');
                break;

            case "datePicker":
                setDateValue('Last 7 Days');
                updatedList.start_date = startDate;
                updatedList.end_date = endDate;
                break;

            case "Custom Date":
                setDateValue('Custom Date');
                return;
                
            default:
                var defaultDate= [...isSavedFilter, {type: 'date', value: 'All Time'}]
                setSavedFilter(defaultDate);
                setDateValue('All Time');
                updatedList.status = 'all';

                updatedList.start_date = '';
                updatedList.end_date = '';
                break;
        }
        updatedList.application = filteredApplication;
        updatedList.status = filteredStatus ? filteredStatus : 'all';
        setFilter(updatedList);
        // console.log('updatedList',filteredStatus.length ,updatedList,startDate,endDate)
    }

    function handleSearch(e) {
        let key = e.target.value
        if (key.substring(0,1) === '0') {
          key = key.replace("0", "62")
        }
        setSearch(key);
        delayedQuery(key);
      }
      
      const delayedQuery = async (q) => {
        searchKey(q)
        
        clearTimeout(timer)
        
        const newTimer = setTimeout(async() => {
            changeCriteria({ page: 1, limit: 10});
            setUpdatedChange(!isUpdatedChange)
        }, 500)
      
        setTimer(newTimer)
      }

    function deleteSelectedFilter(item) {
        let updatedList = [...isSavedFilter];
        updatedList.splice(isSavedFilter.findIndex(d => d.value === item.value), 1);
        // updatedList.push({type: 'date', value: 'All Time'})

        // let resetList = isFilter;
        // resetList.start_date = '';
        // resetList.end_date = '';

        // setFilter(resetList);
        setSavedFilter(updatedList);
    }

    let dateRangeRef = useRef()
    function handleClickDate(value){
      console.log('dateRangeRef',value,dateRangeRef)
      dateRangeRef?.current?.show()
    }
    console.log('dateRangeRef',dateRangeRef)

  
  const container=useRef();
  useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
          console.log('event targets',event,container)
          if (container.current && !container.current.contains(event.target)) {
            setShowFilter(false);
            setShowDate(false);
          }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
          // Unbind the event listener on clean up
          document.removeEventListener("mousedown", handleClickOutside);
      };
  }, [container])

  function resetDate(){
    setStartDate("")
    setEndDate("")
    setTextDate('All Time');
  }

  function handleOnchangeDate(value) {
    setShowFilter(false)
    if (value.value ) {
      setStartDate(moment(value.value[0]).format("YYYY-MM-DD"));
      setEndDate(moment(value.value[1]).format("YYYY-MM-DD"));

      setTextDate(formatDate(new Date(value.value[0])) + ' - ' + formatDate(new Date(value.value[1])))

      let valueDate = formatDate(new Date(value.value[0])) + ' - ' + formatDate(new Date(value.value[1]));

      var defaultDate= [...isSavedFilter.filter(d => d.type !== 'date'), {type: 'date', value: 'datePicker', data: valueDate}]
      setSavedFilter(defaultDate);
      
    }else{
      setStartDate("");
      setEndDate("")
    }
    setRangeDate(value.value)
    rangeDate
  }

  const formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

  return (
    <div className="d-flex flex-column container-filter w-100">
        <div className='d-flex justify-content-between align-items-center'>
            <div className="d-flex flex-row list-filter">
                <div className="d-flex position-relative">
                    <div onClick={() => {setShowFilter(!isShowFilter); setShowDate(false)}} className="d-flex flex-row item">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.25 1.5H3.75C3.15326 1.5 2.58097 1.73705 2.15901 2.15901C1.73705 2.58097 1.5 3.15326 1.5 3.75V4.6275C1.4999 4.9372 1.56373 5.2436 1.6875 5.5275V5.5725C1.79346 5.81323 1.94354 6.03199 2.13 6.2175L6.75 10.8075V15.75C6.74974 15.8774 6.78198 16.0029 6.84365 16.1144C6.90533 16.2259 6.99442 16.3199 7.1025 16.3875C7.22186 16.4614 7.35958 16.5004 7.5 16.5C7.61737 16.4993 7.73303 16.471 7.8375 16.4175L10.8375 14.9175C10.9612 14.8552 11.0652 14.7598 11.138 14.642C11.2109 14.5242 11.2495 14.3885 11.25 14.25V10.8075L15.84 6.2175C16.0265 6.03199 16.1765 5.81323 16.2825 5.5725V5.5275C16.4166 5.24582 16.4907 4.93933 16.5 4.6275V3.75C16.5 3.15326 16.2629 2.58097 15.841 2.15901C15.419 1.73705 14.8467 1.5 14.25 1.5ZM9.9675 9.9675C9.89797 10.0375 9.843 10.1207 9.80565 10.2121C9.76837 10.3034 9.7494 10.4013 9.75 10.5V13.785L8.25 14.535V10.5C8.2506 10.4013 8.23163 10.3034 8.19435 10.2121C8.157 10.1207 8.10203 10.0375 8.0325 9.9675L4.0575 6H13.9425L9.9675 9.9675ZM15 4.5H3V3.75C3 3.55108 3.07902 3.36032 3.21967 3.21967C3.36032 3.07902 3.55109 3 3.75 3H14.25C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.9209 3.36032 15 3.55108 15 3.75V4.5Z" fill="#42526E"/>
                        </svg>
                        <div className="title">Filters</div>
                    </div>
                    {isShowFilter && <FilterDropdown setSavedFilter={setSavedFilter} ListAgent={ListAgent} isListStatus={isListStatus} SavedFilter={isSavedFilter} />}
                    
                </div>
                <div className="d-flex position-relative">
                    {/* <div onClick={() => {setShowDate(!isShowDate); setShowFilter(false)}} className="d-flex flex-row item">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.25 3H12.75V2.25C12.75 2.05109 12.671 1.86032 12.5303 1.71967C12.3897 1.57902 12.1989 1.5 12 1.5C11.8011 1.5 11.6103 1.57902 11.4697 1.71967C11.329 1.86032 11.25 2.05109 11.25 2.25V3H6.75V2.25C6.75 2.05109 6.67098 1.86032 6.53033 1.71967C6.38968 1.57902 6.19891 1.5 6 1.5C5.80109 1.5 5.61032 1.57902 5.46967 1.71967C5.32902 1.86032 5.25 2.05109 5.25 2.25V3H3.75C3.15326 3 2.58097 3.23705 2.15901 3.65901C1.73705 4.08097 1.5 4.65326 1.5 5.25V14.25C1.5 14.8467 1.73705 15.419 2.15901 15.841C2.58097 16.2629 3.15326 16.5 3.75 16.5H14.25C14.8467 16.5 15.419 16.2629 15.841 15.841C16.2629 15.419 16.5 14.8467 16.5 14.25V5.25C16.5 4.65326 16.2629 4.08097 15.841 3.65901C15.419 3.23705 14.8467 3 14.25 3ZM15 14.25C15 14.4489 14.921 14.6397 14.7803 14.7803C14.6397 14.921 14.4489 15 14.25 15H3.75C3.55109 15 3.36032 14.921 3.21967 14.7803C3.07902 14.6397 3 14.4489 3 14.25V9H15V14.25ZM15 7.5H3V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H5.25V5.25C5.25 5.44891 5.32902 5.63968 5.46967 5.78033C5.61032 5.92098 5.80109 6 6 6C6.19891 6 6.38968 5.92098 6.53033 5.78033C6.67098 5.63968 6.75 5.44891 6.75 5.25V4.5H11.25V5.25C11.25 5.44891 11.329 5.63968 11.4697 5.78033C11.6103 5.92098 11.8011 6 12 6C12.1989 6 12.3897 5.92098 12.5303 5.78033C12.671 5.63968 12.75 5.44891 12.75 5.25V4.5H14.25C14.4489 4.5 14.6397 4.57902 14.7803 4.71967C14.921 4.86032 15 5.05109 15 5.25V7.5Z" fill="#42526E"/>
                        </svg>
                        <div className="title">{isDateValue}</div>
                    </div> */}
                    {/* <DateRangePicker ref={listenerRef} ranges={[]}
                        disabledDate={combine(allowedMaxDays(7), afterToday())} 
                        onChange={(value) => onDateChange(value)}
                        className="custom-daterange-pos"
                    /> */}
                    {/* {isShowDate && <DateDropdown setShowDate={setShowDate} isFilter={isFilter} setFilter={setFilter} setSavedFilter={setSavedFilter} handleOnDaterange={handleOnDaterange} SavedFilter={isSavedFilter}/>} */}
                    {/* <DateRangePickerComponent
                    ref={dateRangeRef}
                    enableRtl={true}
                    className='custom-ej2date'   
                    placeholder='Choose date'>
                        <PresetsDirective>
                            <PresetDirective label="Today" start={today} end={today}></PresetDirective>
                            <PresetDirective label="Yesterday" start={yesterday} end={today}></PresetDirective>
                            <PresetDirective label="Last 7 Days" start={weekEnd} end={today}></PresetDirective>
                            <PresetDirective label="Last 30 Days" start={monthStart} end={today}></PresetDirective>
                            <PresetDirective label="Last Year" start={yearStart} end={yearEnd}></PresetDirective>
                        </PresetsDirective>
                    </DateRangePickerComponent> */}

                    <div className='custom-ej2date datepicker-control-section'>
                        <DateRangePickerComponent
                        delayUpdate={true}
                        ref={(scope)=>{dateRangeRef.current = scope}}
                        enableRtl={true}
                        className='custom-ej2date'   
                        change={handleOnchangeDate}
                        minDays={1} 
                        maxDays={31}
                        // onClick={handleClickDate}
                        placeholder='Choose date'>
                            <PresetsDirective>
                                <PresetDirective label="Today" start={today} end={today}></PresetDirective>
                                <PresetDirective label="Yesterday" start={yesterday} end={today}></PresetDirective>
                                <PresetDirective label="Last 7 Days" start={weekEnd} end={today}></PresetDirective>
                                <PresetDirective label="Last 30 Days" start={monthStart} end={today}></PresetDirective>
                                {/* <PresetDirective label="Last Month" start={lastStart} end={lastEnd}></PresetDirective> */}
                                {/* <PresetDirective label="Last Year" start={yearStart} end={yearEnd}></PresetDirective> */}
                            </PresetsDirective>
                        </DateRangePickerComponent>
                        <div className="form-control wrap-date-ejs d-flex align-items-center" style={{marginTop:'-33px',position:'relative'}}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.25 3H12.75V2.25C12.75 2.05109 12.671 1.86032 12.5303 1.71967C12.3897 1.57902 12.1989 1.5 12 1.5C11.8011 1.5 11.6103 1.57902 11.4697 1.71967C11.329 1.86032 11.25 2.05109 11.25 2.25V3H6.75V2.25C6.75 2.05109 6.67098 1.86032 6.53033 1.71967C6.38968 1.57902 6.19891 1.5 6 1.5C5.80109 1.5 5.61032 1.57902 5.46967 1.71967C5.32902 1.86032 5.25 2.05109 5.25 2.25V3H3.75C3.15326 3 2.58097 3.23705 2.15901 3.65901C1.73705 4.08097 1.5 4.65326 1.5 5.25V14.25C1.5 14.8467 1.73705 15.419 2.15901 15.841C2.58097 16.2629 3.15326 16.5 3.75 16.5H14.25C14.8467 16.5 15.419 16.2629 15.841 15.841C16.2629 15.419 16.5 14.8467 16.5 14.25V5.25C16.5 4.65326 16.2629 4.08097 15.841 3.65901C15.419 3.23705 14.8467 3 14.25 3ZM15 14.25C15 14.4489 14.921 14.6397 14.7803 14.7803C14.6397 14.921 14.4489 15 14.25 15H3.75C3.55109 15 3.36032 14.921 3.21967 14.7803C3.07902 14.6397 3 14.4489 3 14.25V9H15V14.25ZM15 7.5H3V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H5.25V5.25C5.25 5.44891 5.32902 5.63968 5.46967 5.78033C5.61032 5.92098 5.80109 6 6 6C6.19891 6 6.38968 5.92098 6.53033 5.78033C6.67098 5.63968 6.75 5.44891 6.75 5.25V4.5H11.25V5.25C11.25 5.44891 11.329 5.63968 11.4697 5.78033C11.6103 5.92098 11.8011 6 12 6C12.1989 6 12.3897 5.92098 12.5303 5.78033C12.671 5.63968 12.75 5.44891 12.75 5.25V4.5H14.25C14.4489 4.5 14.6397 4.57902 14.7803 4.71967C14.921 4.86032 15 5.05109 15 5.25V7.5Z" fill="#42526E"/>
                            </svg>
                            <input
                            style={{width:'80%',cursor:'pointer',color:'#42526E'}} 
                            type="text" 
                            className='w-full input-time-custom cursor-pointer ms-2'
                            onClick={handleClickDate}
                            value={isTextDate}
                            required="required"
                            placeholder="placetext"/>
                            {
                                isTextDate !== 'All Time' &&
                                <img className='ic-reset pinkic-hover' onClick={resetDate} src={Close}></img>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex flex-row search-item">
                <img src={searchIcon} alt="" />   
                <input type="text" value={isSearch} onChange={handleSearch}
                    className="appearance-none text-xs lg:text-xss md:text-xss bg-transparent border-none w-100 text-gray-700 leading-tight focus:outline-none"  
                    placeholder="Search by template name..."  /> 
            </div>
        </div>

        <div className="d-flex flex-row list-selected-filter margin-bottom-10">
            {isSavedFilter && isSavedFilter.filter(item => item.value !== 'All Time').map((item, index) => {
                return (
                    <div key={index} onClick={() => deleteSelectedFilter(item)}
                    className={`d-flex flex-row item ${item.type === 'application' && 'item-channel'} ${item.type === 'status' && 'item-label'} ${item.type === 'agent' && 'item-agent'} ${item.type === 'date' && 'item-date'} ` }>
                        {item.type === 'date' ? 
                            <span>{item.data}</span> :
                            <span>{item.value}</span>
                        }
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.05743 4.99999L9.28242 1.78252C9.42365 1.64129 9.503 1.44974 9.503 1.25002C9.503 1.05029 9.42365 0.858748 9.28242 0.717516C9.1412 0.576291 8.94965 0.496948 8.74993 0.496948C8.5502 0.496948 8.35865 0.576291 8.21742 0.717516L4.99993 3.94249L1.78246 0.717516C1.64123 0.576291 1.44968 0.496948 1.24996 0.496948C1.05023 0.496948 0.85868 0.576291 0.717455 0.717516C0.57623 0.858748 0.496888 1.05029 0.496888 1.25002C0.496888 1.44974 0.57623 1.64129 0.717455 1.78252L3.94243 4.99999L0.717455 8.21749C0.647158 8.28724 0.591365 8.37019 0.553288 8.46161C0.51521 8.55296 0.495605 8.65099 0.495605 8.74999C0.495605 8.84906 0.51521 8.94709 0.553288 9.03844C0.591365 9.12986 0.647158 9.21281 0.717455 9.28249C0.787175 9.35284 0.870125 9.40864 0.96152 9.44666C1.05292 9.48476 1.15095 9.50434 1.24996 9.50434C1.34896 9.50434 1.447 9.48476 1.53839 9.44666C1.62979 9.40864 1.71274 9.35284 1.78246 9.28249L4.99993 6.05749L8.21742 9.28249C8.28717 9.35284 8.37013 9.40864 8.46155 9.44666C8.5529 9.48476 8.65093 9.50434 8.74993 9.50434C8.849 9.50434 8.94703 9.48476 9.03838 9.44666C9.1298 9.40864 9.21275 9.35284 9.28242 9.28249C9.35277 9.21281 9.40858 9.12986 9.4466 9.03844C9.4847 8.94709 9.50427 8.84906 9.50427 8.74999C9.50427 8.65099 9.4847 8.55296 9.4466 8.46161C9.40858 8.37019 9.35277 8.28724 9.28242 8.21749L6.05743 4.99999Z" fill="#1D67CB"/>
                        </svg>
                    </div>
                )}
            )}
        </div>
    </div>
  )
}

FilterTable.propTypes = {
    searchKey: PropTypes.isRequired,
    ListAgent: PropTypes.isRequired,
    isListStatus: PropTypes.isRequired,
    setUpdatedChange: PropTypes.func,
    isUpdatedChange: PropTypes.bool,
    // isPagination: PropTypes.object,
    setFilter: PropTypes.func,
    isFilter: PropTypes.object,
    changeCriteria : PropTypes.object,
  }

export default FilterTable;